// @flow

import React, { useState, useEffect } from "react";
import _ from "lodash";

import Film from "./Film";
import Menu from "./Menu";
import Header from "./Header";
import Upcoming from "./Upcoming";

const Films = ({ films, categories, initialActiveCategory, upcoming }): React$Element<div> => {
  const [activeCategory, setActiveCategory] = useState(initialActiveCategory);
  const setCategory = (slug) => {
    setActiveCategory(slug);
    const url = slug === "all" ? "/kinderfilms" : `/kinderfilms/categorie/${slug}`;
    window.history.pushState({slug: slug}, "", url);
  }
  const currentCategory = categories.find((category) => category.slug === activeCategory);
  
  const listenToPopstate = (e) => {
    if (e.state && e.state.slug) {
      setActiveCategory(e.state.slug);
    }
  }

  useEffect(() => {
    window.history.replaceState({slug: activeCategory}, "");
    window.addEventListener("popstate", listenToPopstate);
    return () => {
      window.removeEventListener("popstate", listenToPopstate);
    };
  }, []);

  const [query, setQuery] = useState("");

  const filteredFilms = _.filter(films, (film) => {
    if (query !== "") {
      return _.includes(film.title.toLowerCase(), query.toLowerCase());
    }
    return _.isEqual(_.intersection(film.categories, currentCategory.tags), currentCategory.tags);
  });

  return (
    <div className="l-content">
      <Header background={currentCategory.header} />
      {upcoming &&
        <Upcoming broadcast={upcoming} />}
      <div className="u-margin-top">
        <Menu categories={categories} activeCategory={activeCategory} setCategory={setCategory} query={query} setQuery={setQuery} />
      </div>
      <div className="u-margin-top l-row l-row--grid">
        {filteredFilms.map((film, i) =>
          <Film key={i} film={film} />
        )}
        {filteredFilms.length === 0 && (
          <div className="l-col-12 u-centered u-margin-top-2">
            <p className="heading">Helaas, er zijn geen films gevonden.</p>
            <p className="heading heading--grey heading--s">Probeer een andere term of <a href="/zoeken">zoek in de hele site</a>.</p>
          </div>
        )}
      </div>
      <div className="u-hidden-m">
        <div className="u-margin-top-2 box box--white padding-4">
          <h1 className="heading">{currentCategory.title}</h1>
          {currentCategory.description}
        </div>
      </div>
    </div>
  )
}

export default Films;
